import { useNavigate } from 'react-router-dom';

export default function Page404() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-6">
      <div className="text-center max-w-sm w-full">

        {/* Icon card */}
        <div className="relative mx-auto w-28 h-28 mb-6">
          <div className="absolute inset-0 bg-blue-500/10 rounded-3xl rotate-6" />
          <div className="absolute inset-0 bg-blue-500/10 rounded-3xl -rotate-3" />
          <div className="relative w-full h-full bg-gray-800 rounded-3xl flex items-center justify-center border border-gray-700/60">
            <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-blue-400">
              <path d="M3 7a2 2 0 012-2h14a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V7z"/>
              <path d="M3 7l9 6 9-6"/>
              <line x1="9" y1="14" x2="9" y2="14"/>
              <path d="M9 17h6" strokeDasharray="2 2"/>
            </svg>
          </div>
        </div>

        {/* Code */}
        <p className="text-[96px] font-black leading-none text-blue-500/15 select-none -mb-4">404</p>

        {/* Text */}
        <h1 className="text-2xl font-bold text-white mb-2">Sayfa Bulunamadı</h1>
        <p className="text-gray-400 text-sm leading-relaxed mb-8">
          Aradığınız sayfa mevcut değil veya taşınmış olabilir.
          <br />URL adresini kontrol edip tekrar deneyin.
        </p>

        {/* Actions */}
        <div className="flex flex-wrap gap-3 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="px-5 py-2.5 rounded-xl bg-gray-800 hover:bg-gray-700 text-gray-300 text-sm font-medium border border-gray-700 transition-colors">
            ← Geri Dön
          </button>
          <button
            onClick={() => navigate('/')}
            className="px-5 py-2.5 rounded-xl bg-blue-600 hover:bg-blue-500 text-white text-sm font-medium transition-colors">
            Ana Sayfa
          </button>
        </div>
      </div>
    </div>
  );
}
